// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { isNonStockProduct } from "@steiner/App/Store/Selectors/ProductDetailsSelector";
import ProductPrice, { ProductPriceStyles } from "@steiner/Overrides/Components/ProductPrice";
import * as React from "react";
import { connect } from "react-redux";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomAppState, ownProps: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    // XNG-Changes
    isNonStockItem: isNonStockProduct(state, ownProps.productContext.productInfo.productId),
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({
    productContext,
    productSettings,
    // XNG-Changes
    isNonStockItem,
}) => {
    if (isNonStockItem) {
        return null;
    }

    return (
        <ProductPrice
            product={productContext}
            showLabel={false}
            showSavings={true}
            showSavingsAmount={productSettings.showSavingsAmount}
            showSavingsPercent={productSettings.showSavingsPercent}
            extendedStyles={styles.productPrice}
            // XNG-Change
            customSalePriceLabel={translate("Your Cost:")}
            customSaleRegularPriceLabel={translate("List")}
            isProductDetailsPage={true}
            showPricePerUom={true}
            hideSaleRegularLabel={false}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
